import Swiper from 'swiper/bundle';

const init = () => {
  const carousel = document.querySelector('.konintodoke-top-carousel')
  const indicatorItems = Array.from(document.querySelectorAll('.konintodoke-top-carousel-indicator__item'))

  if (!carousel) return

  // モーション嫌悪設定のユーザーには自動再生を無効化(メッセージループのreduced-motion対応と基準を揃える)
  // NOTE: 通常設定向けの停止手段(WCAG 2.2.2)は別途検討
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  const updateIndicator = (activeIndex) => {
    indicatorItems.forEach((item, index) => {
      item.classList.toggle('-active', index === activeIndex)
    })
  }

  const swiper = new Swiper(".konintodoke-top-carousel", {
    loop: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    speed: 700,
    spaceBetween: 46,
    // 初期化時にフォント/画像/レイアウトが未確定だと centeredSlides の中央位置がズレる
    // (Android Chrome等で初回ランディング時に先頭が中央に来ない)。
    // observerでサイズ変化を監視し、確定後に自動で再計算・中央補正する。
    observer: true,
    observeParents: true,
    autoplay: prefersReducedMotion ? false : {
      delay: 3400,
      disableOnInteraction: false,
    },
    on: {
      init() {
        updateIndicator(this.realIndex)
      },
      slideChange() {
        updateIndicator(this.realIndex)
      },
    },
  });

  // 初期化直後のレイアウト確定タイミングで中央位置を明示的に補正する
  const recenter = () => swiper.update()
  requestAnimationFrame(recenter)
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(recenter)
  }
}

// window.load(全画像・GTM等の読み込み完了)を待つと、TOPは画像が多く1秒以上遅れて
// 初期化が"パツン"と切り替わって見える。SwiperはDOM構造さえあれば初期化できるため、
// DOMContentLoaded(または既にDOM構築済みなら即時)で初期化する。
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
